import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e68206c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-search" }
const _hoisted_2 = {
  key: 0,
  class: "mobile-search__title"
}
const _hoisted_3 = {
  key: 1,
  class: "company-info mobile-only"
}
const _hoisted_4 = { class: "company-info__name" }
const _hoisted_5 = { class: "company-info__value no-h-styling" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-star-blue" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-settings" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.currentRoute !== 'company')
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.mobileTitle), 1))
      : _createCommentVNode("", true),
    (_ctx.company && _ctx.currentRoute === 'company')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.company.tin || "–"), 1),
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.company.title), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      action: ".",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleMobileSearch && _ctx.handleMobileSearch(...args)), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "search",
        class: "header-search",
        placeholder: _ctx.mobilePlaceholder,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mobileQuery) = $event)),
        ref: "mobileSearch"
      }, null, 8, _hoisted_6), [
        [_vModelText, _ctx.mobileQuery]
      ]),
      (['tenderSerp', 'company'].includes(_ctx.currentRoute as string))
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isAuthenticated ? _ctx.handleStarClick() : _ctx.toggleAuthModal())),
            class: _normalizeClass(["js-mobile-save-search-template", { 'is-added': _ctx.templateExists }]),
            style: {"cursor":"pointer"}
          }, _hoisted_8, 2))
        : _createCommentVNode("", true),
      (!['templates', 'companies'].includes(_ctx.currentRoute as string))
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileFiltersModal && _ctx.toggleMobileFiltersModal(...args))),
            class: "js-settings",
            style: {"cursor":"pointer"}
          }, _hoisted_10))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}